import React, { useEffect } from "react";
import { isMobile } from "react-device-detect";
import "./login/TelegramLogin.scss";
import useIsAndroid from "../customHooks/useIsAndroid";
import { MyTrips } from "../myTrips/MyTrips";
import { makeAppLink } from "../utils/utils";

export default function LinkToApp({ subDir, alternativeDelayRedirect, desktopRedirect }) {
  const isAndroid = useIsAndroid();
  const isInApp = window.isInApp;
  const appLink = makeAppLink(subDir);

  useEffect(() => {
    const downloadAppRedirect = "/my-trips";
    const redirect = isMobile ? appLink : (desktopRedirect ?? downloadAppRedirect);

    if (!redirect) return;
    setTimeout(() => (window.location.href = redirect), 100);
    if (isMobile && !isInApp) {
      const delay = isAndroid ? "5000" : "3000";
      let delayedRedirect = isAndroid
        ? "https://play.google.com/store/apps/details?id=com.sotravel.sotravel"
        : "https://apps.apple.com/app/id6447177449";

      if (alternativeDelayRedirect) {
        delayedRedirect = alternativeDelayRedirect;
      }
      setTimeout(() => (window.location.href = delayedRedirect), delay);
    }
  }, []);

  return (
    <MyTrips beforeTitle="If the Sotravel app was not automatically opened, you need to download it first." />
  );
}
